import React from 'react';
import { Button, Tag } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import type { IRoom } from '../store';
import { RoomItemWrapper, StyleItems, IpAddress, ClientIdSpan } from './styles';

type RoomItemProps = {
  osVersion: string;
  type: 'active' | 'waiting' | 'inactive';
  onConnect?: (roomId: string) => void;
} & IRoom;

function renderText(type: 'active' | 'waiting' | 'inactive', subscriber: string | undefined) {
  switch (type) {
    case 'active':
    case 'inactive':
      return subscriber ? `Connected` : 'Connect';
    case 'waiting':
      return 'Waiting';
    default:
      return '';
  }
}

const RoomItem = ({
  clid,
  room_id,
  ip,
  customer_key,
  onConnect,
  subscribers,
  type,
  city,
  osVersion,
}: RoomItemProps) => {
  return (
    <RoomItemWrapper>
      <div>
        <StyleItems>
          <ClientIdSpan>Client ID: {clid}</ClientIdSpan>
          <Tag color={type === 'active' ? 'green' : undefined}>{ip}</Tag>
          <Tag>{osVersion}</Tag>
          {/* <IpAddress $type={type === 'active' ? 'active' : 'inactive'}>IP: {ip}</IpAddress> */}
        </StyleItems>
        <StyleItems>
          {subscribers?.[0] && (
            <>
              <UserOutlined />
              <span>{subscribers?.[0]}</span>
            </>
          )}
        </StyleItems>
      </div>
      <Button
        disabled={type === 'inactive' || type === 'waiting' || !!subscribers?.[0]}
        type="primary"
        onClick={() => onConnect?.(room_id)}
      >
        {renderText(type, subscribers?.[0])}
      </Button>
    </RoomItemWrapper>
  );
};

export default RoomItem;
